@if (mobileStyle) {
  @if (openAlert) {
    <div class="mobile-container">
      <div class="mobile-container__content">
        <div>
          <img [src]="iconImage" />
        </div>
        <div class="--detail-content">
          <!-- Mobile alerts here -->
        </div>
      </div>
      <div class="mobile-container__close" (click)="hide()"></div>
    </div>
  }
} @else {
  <div class="alert-container">
    <div class="alert-container__image-container">
      <img [src]="iconImage" class='popover-image'/>
    </div>
    <div class="alert-container__detail">
      @switch (myTitle) {
        @case ('RESULT-FLEXIBLE-FILTER') {
          <span i18n="@@flexiblerate__alert">
            ¡Comprá tranquilo!<br />Reservá alojamientos que puedas cancelar.
          </span>
        }
        @case ('RESULT-FILTERS-PREPAID') {
          <span i18n="@@payment__pesos">
            Pagás ahora en pesos.
          </span>
        }
        @case ('RESULT-FILTERS-PAY_AT_DESTINATION') {
          <span i18n="@@credit_card__required">
            Necesitás una tarjeta de crédito para garantizar la reserva.
          </span>
        }
      }
    </div>
  </div>
}
